/* Wuschelherz: aus snippets/wh-pdp-r3.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
  (() => {
    if (window.whSaleTop) return; window.whSaleTop = true;
    const mq = window.matchMedia('(max-width: 1023px)');
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      document.querySelectorAll('.wh-pc--clone [data-wh-expires]').forEach((t) => {
        const left = Math.max(0, new Date(t.dataset.whExpires).getTime() - Date.now());
        const parts = [Math.floor(left / 864e5), Math.floor(left / 36e5) % 24, Math.floor(left / 6e4) % 60, Math.floor(left / 1e3) % 60];
        t.querySelectorAll('.countdown__item p').forEach((el, k) => { const v = pad(parts[k] || 0); if (el.textContent !== v) el.textContent = v; });
        if (!left) { const c = t.closest('.wh-pc--clone'); if (c) c.remove(); }
      });
    };
    const sync = () => {
      const fp = document.querySelector('.featured-product');
      if (!fp) return;
      document.querySelectorAll('.wh-pc--clone').forEach((c) => { if (c.parentElement !== fp) c.remove(); });
      const orig = fp.querySelector('product-info .product-countdown.wh-pc:not(.wh-pc--clone)');
      let copy = fp.querySelector(':scope > .wh-pc--clone');
      const timer = orig && orig.querySelector('countdown-timer[data-expires]');
      const over = timer && new Date(timer.dataset.expires).getTime() <= Date.now();
      if (!mq.matches || !orig || over) {
        if (copy) copy.remove();
        if (orig) orig.style.removeProperty('display');
        return;
      }
      if (orig.style.getPropertyValue('display') !== 'none') orig.style.setProperty('display', 'none', 'important');
      if (copy && copy.dataset.src === orig.id) return;
      if (copy) copy.remove();
      copy = orig.cloneNode(true);
      copy.removeAttribute('style');
      // ohne .product-countdown: wh-pdp-ux holt jeden .product-countdown direkt in der Produktspalte vor den Titel
      copy.classList.remove('wh-pc--top', 'product-countdown');
      copy.classList.add('wh-pc--clone');
      copy.dataset.src = orig.id;
      copy.id = orig.id + '-oben';
      copy.querySelectorAll('style').forEach((st) => { st.textContent = st.textContent.split('#' + orig.id).join('#' + copy.id); });
      // Theme-Countdown durch ein schlichtes Element mit gleichem Aufbau ersetzen, den Takt übernimmt tick()
      copy.querySelectorAll('countdown-timer').forEach((ct) => {
        const d = document.createElement('div');
        d.className = ct.className; d.innerHTML = ct.innerHTML; d.dataset.whExpires = ct.dataset.expires || '';
        ct.replaceWith(d);
      });
      fp.prepend(copy);
      tick();
    };
    sync();
    setInterval(tick, 1000);
    // Nach einem Neuaufbau der Produktspalte prüfen (nicht entprellt: der Countdown ändert sich jede Sekunde,
    // eine Entprellung käme nie zum Zug). Timer statt requestAnimationFrame, das in Hintergrund-Tabs ruht.
    let queued = false;
    const request = () => { if (queued) return; queued = true; setTimeout(() => { queued = false; sync(); }, 0); };
    new MutationObserver(request).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    mq.addEventListener('change', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  })();
